import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContactDetails, ContactResponse } from '../../models/contact.model';
import { ContactService } from '../../services/contact.service';
import { DocumentService } from '../../services/document.service';
import { UtilityService } from '../../services/shared/utility.service';
import { isNumber } from 'util';
import { environment } from '../../../environments/environment';

//For jquery
declare var $: any;

@Component({
    selector: 'app-document-export',
    templateUrl: './document-export.component.html',
    styleUrls: ['./document-export.component.css']
})
/** document-export component*/
export class DocumentExportComponent implements OnInit {

    contactResponse: ContactResponse;
    contactDetail: ContactDetails;

    docTypeid: any;
    inventId: any;
    contactId: any;
    contactSessionId: any;
    contractType: any;
    dvSpinner: boolean = false;
    chkExpPDF: boolean = false;
    modalTitle: string = "Generate Documents";
    modalBody: string = "Documents are being generated...";
    logoPath: string = "";
    public appVersion;
    /** document-export ctor */
    constructor(private _router: Router,
        private _route: ActivatedRoute,
        private _contactService: ContactService,
        private _documentService: DocumentService,
        private _utilityService: UtilityService) {
        this.appVersion = environment.appVersion;
        this._route.queryParamMap.subscribe(params => {
            if (params.has('d')) {
                this.docTypeid = params.get('d');
                this.inventId = params.get('i');
                this.contactId = params.get('c');
                this.contactSessionId = params.get('cs');
                this.contractType = params.get('ct');
                //this.logoPath = this.contractType == 'p' ? "assets/images/logo/Patent-Plus.png" : "assets/images/logo/logo_1226.png";
                this.logoPath = "assets/images/logo/logo_1226.png";
            }
        });

    }

    ngOnInit(): void {
        if (Number(this.contactSessionId)) {
            alert("Invalid document download URL for SendToCorp.Please try Resend to Corp or contact administrator!");
            return;
        }
        else this.loadContact(this.contactId);

    }

    private async loadContact(contactId) {
        if (this.docTypeid === "35") {
            this.modalTitle = "Printing Receipt";
            this.modalBody = "Please wait..we are gathering necessary information for you!";
        } else {
            this.modalTitle = "Generate Documents";
            this.modalBody = "Documents are being generated...";
        }
        $('#modalExportDocument').modal('show');
        await this._contactService.getContactAsync("", contactId)
            .then(async (result: ContactResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.contactResponse = UtilityService.clone(result);
                        if (this.contactResponse) {
                            this.contactDetail = UtilityService.clone(this.contactResponse.contactDetails);
                            this.downloadFile("", this.docTypeid, this.inventId, contactId, this.contactSessionId, this.contractType == "p" ? "Plus" : "Normal")
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
                $('#modalExportDocument').modal('hide');
            });
    }

    downloadFile(encryptedUser, docIds, inventionId, contactId, contractSessionId, contractType) {
        this._documentService.getGetDocumentZipEncriptAsync(encryptedUser, docIds, inventionId, contactId, contractSessionId, contractType)
            .then(async (result: any) => {
                if (result) {
                    let file = new Blob([result], { type: 'application/zip' });
                    let fileURL = URL.createObjectURL(file);
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    if (docIds === "35")
                        fileLink.download = "PurchaseReceipt_" + inventionId + ".zip";
                    else {
                        if (this.contactDetail)
                            fileLink.download = "ContractDocuments_" + this.contactDetail.firstname + this.contactDetail.lastname + ".zip";
                        else
                            fileLink.download = "ContractDocuments.zip";
                    }
                    fileLink.click();
                    this.dvSpinner = false;
                    this.chkExpPDF = false;
                    //window.close();
                    //window.open(fileURL, '_self').close();
                    //setTimeout(function () {
                    //    window.open(fileURL, '_blank');
                    //}, 1000);
                    $('#modalExportDocument').modal('hide');
                } else {
                    console.log("exportToPDF.statusCode: Error Getting Data");
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
                $('#modalExportDocument').modal('hide');
            });

    }
}
